import { createSelector } from 'reselect'

const app = (state) => state.app

export const getApp = createSelector(
  [ app ],
  (app) => {
    return Object.assign(
      {},
      app
    )
  }
)

export const getFilter = createSelector(
  [ app ],
  (app) => {
    return Object.assign(
      {},
      {
        filter: app.filter
      }
    )
  }
)



// WEBPACK FOOTER //
// ./src/app/react-redux/selectors/app.js